
import { cn } from "../lib/utils"

import { 

  Radio as HeadlessRadio, 

  RadioGroup as HeadlessRadioGroup

} from "@headlessui/react"

function Radio( { className, ...props } ) {
  
  return (
    
    <HeadlessRadio 

      className={ cn(

        "group flex items-center justify-center size-4.5 rounded-full border border-input bg-grey-abalaster hover:bg-grey-mercury outline-none transition-all",

        "data-checked:bg-blue-fresh data-checked:border-blue-primary focus-visible:ring-[2px] focus-visible:border-blue-fresh focus-visible:ring-blue-fresh/50 aria-invalid:ring-red/20 aria-invalid:border-red",

        className

      ) }

      { ...props }  

    />

  )

}

function RadioGroup( { ...props } ) {

  return <HeadlessRadioGroup className={ cn( "flex flex-col gap-4 sm:gap-6" ) } { ...props } />

}

export { Radio, RadioGroup }
